import { firebase } from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyARmJmIR0WVfe4zr2pEonOD16BtX8L7NVY",
  authDomain: "happyzurich-c38d7.firebaseapp.com",
  databaseURL: "https://happyzurich-c38d7.firebaseio.com",
  projectId: "happyzurich-c38d7",
  storageBucket: "happyzurich-c38d7.appspot.com",
  messagingSenderId: "440362400513"
});

const firestore = firebase.firestore();
 const settings = {timestampsInSnapshots: true};
 firestore.settings(settings);


export const db = firebaseApp.firestore();
